import styles from "./addBooking.module.css";
import { useForm } from "react-hook-form";
import moment from "moment";
import { FormControlLabel, Checkbox } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { authData } from "../../../components/GetAuth";
import { useEffect, useState } from "react";

function Step4({ bookingData, backToTab, setLoading, setSnackbarMessage, setSnackbarType, setSnackbarOpen, booking_id }) {
  const auth = authData();
  const navigate = useNavigate();
  const [SubTotal, setSubTotal] = useState(0);
  const [Total, setTotal] = useState(0);
  const VATCharge = 0;
  const InsuranceCharge = 0;
  const [discountVal, setDiscountVal] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [referralDiscount, setReferralDiscount] = useState(0);
  const [subTotalNew, setSubTotalNew] = useState(0);
  const [productRDiscount, setProductRDiscount] = useState(0);
  const [pickupPhones, setPickupPhones] = useState([]);
  const [receipientPhones, setReceipientPhones] = useState([]);

  const { register, handleSubmit, formState: { errors } } = useForm({ mode: "onChange" });

  useEffect(() => {
    let subtotalTemp = 0;
    let discountTemp = 0;
    let discountTemp2 = 0;

    bookingData?.products?.forEach((item) => {
      subtotalTemp += parseFloat(item.total);
    });
    setSubTotal(subtotalTemp);

    setDiscountVal(bookingData?.discountVal);
    setDiscountAmount(bookingData?.discountAmount);
    setReferralDiscount(bookingData?.referralDiscount);

    if (bookingData?.discountAmount) {
      discountTemp = bookingData?.discountAmount;
    }

    if (bookingData?.referralDiscount) {
      discountTemp2 = bookingData?.referralDiscount;
    }

    let subTotalNewTwmp = bookingData.products.reduce((sum, item) => {
      if (parseFloat(bookingData?.discountVal) > 0) {
        let newDisc = ((parseFloat(item.total) * parseFloat(bookingData?.discountVal)) / 100);
        newDisc = Math.round(newDisc * 100) / 100;

        return sum + parseFloat(item.total) - newDisc;
      }
      return sum + parseFloat(item.total);
    }, 0);

    setSubTotalNew(subTotalNewTwmp);

    setTotal(subtotalTemp + VATCharge + InsuranceCharge - discountTemp - discountTemp2);


    if (bookingData && bookingData?.pickUpData?.phone) {
      let pPhones = [];

      if (bookingData?.pickUpData?.alt_phones && bookingData?.pickUpData?.alt_phones?.length > 0) {
        pPhones = bookingData?.pickUpData?.alt_phones?.map(i => {
          return i?.value;
        });
      }

      setPickupPhones([bookingData?.pickUpData?.phone].concat(pPhones));
    }

    if (bookingData && bookingData?.recipientData?.phone) {
      let pPhones = [];

      if (bookingData?.recipientData?.alt_phones && bookingData?.recipientData?.alt_phones?.length > 0) {
        pPhones = bookingData?.recipientData?.alt_phones?.map(i => {
          return i?.value;
        });
      }

      setReceipientPhones([bookingData?.recipientData?.phone].concat(pPhones));
    }

  }, [bookingData]);

  useEffect(() => {
    if (bookingData?.referralDiscount) {
      if (parseFloat(bookingData?.referralDiscount) > 0 && subTotalNew > 0) {
        let refDiscP = parseFloat(bookingData?.referralDiscount) / parseFloat(subTotalNew);
        refDiscP = Math.round(refDiscP * 10000) / 10000;

        setProductRDiscount(refDiscP);
      }
    }
  }, [bookingData?.referralDiscount, subTotalNew]);

  const onSubmit = (data) => {
    let noOfItems = bookingData.products.length;
    let subTotal = 0;

    let products = bookingData.products.map((item) => {
      let newTotal = parseFloat(item.total);
      subTotal += parseFloat(item.total);
      let newDisc = 0;
      if (discountVal > 0) {
        let newDisc1 = ((newTotal * discountVal) / 100);
        newDisc1 = Math.round(newDisc1 * 100) / 100;

        newDisc += newDisc1;
        newTotal = newTotal - newDisc1;
      }
      if (productRDiscount > 0) {
        let newDisc2 = (newTotal * productRDiscount);
        newDisc2 = Math.round(newDisc2 * 100) / 100;

        newDisc += newDisc2;
        newTotal = newTotal - newDisc2;
      }

      let product_title = item?.item_name;
      if (item?.item_id === 0) {
        product_title = 'Other- ' + item?.item_name;
      }

      let pObj = {
        product_id: item?.item_id,
        product_title: product_title,
        price: item.total,
        quantity: 1,
        subtotal: item.total,
        discount: newDisc,
        sub_amount: newTotal,
        is_fragile: item?.is_fragile ? 1 : 0,
        estimated_value: item?.estimated_value ?? 0,
      };

      if (item?.category_id === -1) {
        pObj = { ...pObj, length: item?.length, width: item?.width, height: item?.height, is_dimension: 1 }
      }

      if (bookingData?.freight_type === 'Air Freight') {
        pObj = { ...pObj, weight: item?.weight }
      }

      return pObj;
    });

    let alt_phones_p = bookingData?.pickUpData?.alt_phones?.map(i => {
      return i?.value;
    });

    let alt_phones_r = bookingData?.recipientData?.alt_phones?.map(i => {
      return i?.value;
    });

    let postData = {
      customer_id: bookingData?.customer_id,
      description: bookingData?.notes,
      no_of_items: noOfItems,
      insurance: bookingData?.insurance,
      company_shipping: bookingData?.company_shipping,
      company_name: bookingData?.company_name,
      registered_company: bookingData?.registered_company,
      pickup_date: moment(bookingData?.pickup_date).format("YYYY-MM-DD"),
      total: subTotal - discountAmount - referralDiscount,
      amount: subTotal,
      post_code: bookingData?.pickUpData?.post_code,
      products: products,
      pickUpData: { ...bookingData?.pickUpData, alt_phones: alt_phones_p },
      recipientData: { ...bookingData?.recipientData, alt_phones: alt_phones_r },
      discount_val: discountVal,
      discount_amount: discountAmount,
      referral_discount: referralDiscount,
      freight_type: bookingData?.freight_type || 'Sea Freight'
    };

    setLoading(true);

    if (booking_id) {
      axios.post(process.env.REACT_APP_API_URL + "v1/bookings/" + booking_id, postData, {
        headers: { Authorization: `Bearer ${auth?.api_token}` }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");
          navigate("/booking/list");
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message || "Something went wrong. Please try again.");
          setSnackbarType("error");
        }
      }).catch((error) => {
        setLoading(false);
        setSnackbarOpen(true);
        setSnackbarMessage(error?.response?.data?.message || "Something went wrong. Please try again.");
        setSnackbarType("error");
      });
    } else {
      axios.post(process.env.REACT_APP_API_URL + "v1/bookings", postData, {
        headers: { Authorization: `Bearer ${auth?.api_token}` }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");
          navigate("/booking/list");
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message || "Something went wrong. Please try again.");
          setSnackbarType("error");
        }
      }).catch((error) => {
        setLoading(false);
        setSnackbarOpen(true);
        setSnackbarMessage(error?.response?.data?.message || "Something went wrong. Please try again.");
        setSnackbarType("error");
      });
    }
  }

  console.log('bookingData');
  console.log(bookingData);

  return (<>
    <div className={`${styles.CustomWidth}`}>
      <div className={`${styles.SummerySec}`}>
        <div className={`${styles.SummerySecRow}`}>
          <div className={`${styles.SummerySecFull}`}>
            <p>Customer Name:</p>
            <p>{bookingData?.customer?.name}</p>
          </div>
          <div className={`${styles.SummerySecFull}`}>
            <p>Freight Option:</p>
            <p>{bookingData?.freight_type || 'Sea Freight'}</p>
          </div>
          <div className={`${styles.SummerySecHalf} ${styles.SummerySecHalf1}`}>
            <p className={`${styles.StepBoxTitle2}`}>Confirm your pickup details</p>
            <ul className={`${styles.SummeryListSec}`}>
              <li>
                <p className={`${styles.SummeryHeadTitle}`}>Name:</p>
                <p className={`${styles.SummeryHeadText}`}>{bookingData?.pickUpData?.name}</p>
              </li>
              <li>
                <p className={`${styles.SummeryHeadTitle}`}>Address:</p>
                <p className={`${styles.SummeryHeadText}`}>{bookingData?.pickUpData?.address}</p>
              </li>
              <li>
                <p className={`${styles.SummeryHeadTitle}`}>Post Code:</p>
                <p className={`${styles.SummeryHeadText}`}>{bookingData?.pickUpData?.post_code}</p>
              </li>
              <li>
                <p className={`${styles.SummeryHeadTitle}`}>Phone:</p>
                <p className={`${styles.SummeryHeadText}`}>{pickupPhones.join(', ')}</p>
              </li>
            </ul>
          </div>

          <div className={`${styles.SummerySecHalf}  ${styles.SummerySecHalf2}`}>
            <p className={`${styles.StepBoxTitle2}`}>Confirm your recipient details</p>
            <ul className={`${styles.SummeryListSec}`}>
              <li>
                <p className={`${styles.SummeryHeadTitle}`}>Name:</p>
                <p className={`${styles.SummeryHeadText}`}>{bookingData?.recipientData?.name}</p>
              </li>
              <li>
                <p className={`${styles.SummeryHeadTitle}`}>Address:</p>
                <p className={`${styles.SummeryHeadText}`}>{bookingData?.recipientData?.address}</p>
              </li>
              <li>
                <p className={`${styles.SummeryHeadTitle}`}>Phone:</p>
                <p className={`${styles.SummeryHeadText}`}>{receipientPhones.join(', ')}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <p className={`${styles.StepBoxTitle}`}>Confirm your item details</p>
      <div className={`${styles.TableSec}`}>
        <table>
          <tbody>
            <tr className={styles.TableHeadRow}>
              <td className={`${styles.TableHead}`}>Pickup Item</td>
              {bookingData?.freight_type === 'Air Freight' && (
                <td className={`${styles.TableHead}`}>Weight</td>
              )}
              <td className={`${styles.TableHead}`}>Fragile</td>
              <td className={`${styles.TableHead}`}>Estimated Value</td>
              <td className={`${styles.TableHead}`}>Total</td>
            </tr>
            {bookingData?.products?.map((item, idx) => {
              let discTemp = 0;
              let newTotal = (parseFloat(item.total));
              if (discountVal > 0) {
                let discTemp1 = ((newTotal * discountVal) / 100);
                discTemp1 = Math.round(discTemp1 * 100) / 100;

                discTemp += discTemp1;
                newTotal = newTotal - discTemp1;
              }

              if (productRDiscount > 0) {
                let newDisc2 = (newTotal * productRDiscount);
                newDisc2 = Math.round(newDisc2 * 100) / 100;

                discTemp += newDisc2;
              }

              let product_title = item?.item_name;
              if (item?.item_id === 0) {
                product_title = 'Other- ' + item?.item_name;
              }

              return (<tr data-row="item" key={item?.id ?? idx}>
                <td className={`${styles.TableCon}`} data-label="Item">
                  <span>
                    {product_title}
                    {parseInt(item?.category_id) === -1 && <>
                      <br />
                      <span style={{ fontSize: '11px' }}>Dimension: <strong>L:{item?.length}</strong> <strong>W:{item?.width}</strong> <strong>H:{item?.height}</strong></span>
                    </>}
                  </span>
                </td>
                {bookingData?.freight_type === 'Air Freight' && (
                  <td className={`${styles.TableCon}`} data-label="Weight">
                    {item?.weight ? `${item.weight} kg` : '-'}
                  </td>
                )}
                <td className={`${styles.TableCon}`} data-label="Fragile">{item?.is_fragile ? "Yes" : "No"}</td>
                <td className={`${styles.TableCon}`} data-label="Estimated Value">
                  <span>
                    &pound; {parseFloat(item.estimated_value ?? item.total).toFixed(2)}
                    {discountVal > 0 && <>
                      <br />
                      <span style={{ fontSize: '12px' }}>(-&pound; {parseFloat(discTemp).toFixed(2)})</span>
                    </>}
                  </span>
                </td>

                <td className={`${styles.TableCon}`} data-label="Total">
                  <span>
                    &pound; {parseFloat(item.total).toFixed(2)}
                    {discountVal > 0 && <>
                      <br />
                      <span style={{ fontSize: '12px' }}>(-&pound; {parseFloat(discTemp).toFixed(2)})</span>
                    </>}
                  </span>
                </td>
              </tr>);
            })}
            <tr data-row="totals">
              <td colSpan={bookingData?.freight_type === 'Air Freight' ? 4 : 3} className={`${styles.TableCon}`} style={{ background: 'transparent' }}>
                <p className={`${styles.SummeryPPTI}`}>Order Subtotal:</p>
                {discountVal > 0 && <p className={`${styles.SummeryPPTI}`}>Membership Discount({discountVal}%):</p>}
                {referralDiscount > 0 && <p className={`${styles.SummeryPPTI}`}>Referral Discount:</p>}
                <p className={`${styles.SummeryPPTI}`}>Total VAT:</p>
                <p className={`${styles.SummeryPPTI}`}>Insurance Charges:</p>
                <p className={`${styles.SummeryPPTI} ${styles.Big}`}>Total:</p>
              </td>
              <td className={`${styles.TableCon}`} style={{ background: 'transparent' }}>
                <p className={`${styles.SummeryPPTE}`}>£{SubTotal.toFixed(2)}</p>
                {discountVal > 0 && <p className={`${styles.SummeryPPTE}`}>-£{discountAmount.toFixed(2)}</p>}
                {referralDiscount > 0 && <p className={`${styles.SummeryPPTE}`}>-£{referralDiscount.toFixed(2)}</p>}
                <p className={`${styles.SummeryPPTE}`}>£{VATCharge.toFixed(2)}</p>
                <p className={`${styles.SummeryPPTE}`}>£{InsuranceCharge.toFixed(2)}</p>
                <p className={`${styles.SummeryPPTE} ${styles.Big}`}>£{Total.toFixed(2)}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className={`${styles.TableConSec}`}>
        <p className={`${styles.TableConSecTitle}`}>To be collected:</p>
        <p className={`${styles.TableConSecText}`}>{moment(bookingData.pickup_date).format("ddd MMM D, YYYY")}</p>
      </div>

      <div className={`${styles.TableConSec}`}>
        <p className={`${styles.TableConSecTitle}`}>Booking Notes:</p>
        <p className={`${styles.TableConSecText}`}>{bookingData?.notes}</p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControlLabel
          control={<Checkbox {...register("is_accept", { required: true })} />}
          label="I confirm that the order summary above is correct *"
          className={`${styles.CheckBox}`}
        />
        {errors?.is_accept && (<p className={`${styles.ErrorM}`}>Please accept terms & condition</p>)}

        <div className={`${styles.StepBUSec}`}>
          <button type="button" onClick={backToTab} className={`${styles.Previous}`}>Back</button>
          <button type="submit" className={`${styles.Next}`}>Confirm Booking</button>
        </div>
      </form>
    </div>
  </>);
}

export default Step4;